import { forwardRef, type ChangeEvent, type ComponentPropsWithoutRef } from 'react';

export type TextInputProps = Omit<
  ComponentPropsWithoutRef<'input'>,
  'onChange' | 'value' | 'defaultValue'
> & {
  value: string;
  onChange: (value: string) => void;
};

/** Controlled text input with string-based onChange callback. */
export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
  { value, onChange, className, type = 'text', ...props },
  ref,
): React.JSX.Element {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onChange(event.target.value);
  };

  const classes = ['input', className].filter(Boolean).join(' ');

  return (
    <input
      ref={ref}
      type={type}
      value={value}
      className={classes}
      onChange={handleChange}
      {...props}
    />
  );
});
